// extracted by mini-css-extract-plugin
export var currentPage = "pagination-module--currentPage--67aa5";
export var disabled = "pagination-module--disabled--04932";
export var paginationItem = "pagination-module--paginationItem--7dfae";
export var paginationItems = "pagination-module--paginationItems--84aa8";
export var paginationSideButton = "pagination-module--paginationSideButton--1b8c3";
export var paginationWrapper = "pagination-module--paginationWrapper--41c95";